import { createContext, useContext } from 'react';

export const drawerWidth = 300;

export const DashboardLayoutContext = createContext({
  isNavOpen: true,
});

export const useDashboardLayout = () => useContext(DashboardLayoutContext);
